// src/pages/help/EventsHelp.js
import React from "react";
import { Link } from "react-router-dom";

const EventsHelp = () => {
  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <div className="mb-6">
        <Link to="/help" className="text-deep-red hover:text-bright-red">
          &larr; Back to Help Center
        </Link>
      </div>
      <h1 className="text-3xl font-bold text-dark-grey mb-6">Events Help</h1>
      <div className="space-y-6">
        <section>
          <h2 className="text-2xl font-semibold text-dark-grey mb-4">Understanding Events</h2>
          <p className="text-medium-grey">
            Events are individual UFC fight cards or competitions. Each event contains multiple fights
            across different weight classes. Players can submit their fighter lineup for each event to
            earn points in their fantasy leagues.
          </p>
        </section>
        
        <section>
          <h2 className="text-2xl font-semibold text-dark-grey mb-4">Event Timeline</h2>
          <p className="text-medium-grey mb-4">
            Events go through several phases:
          </p>
          <ul className="list-disc pl-5 text-medium-grey space-y-2">
            <li><span className="font-medium">Upcoming:</span> Events that have been announced but haven't started yet. You can submit fighter lineups during this phase.</li>
            <li><span className="font-medium">Live:</span> Events that are currently taking place. You cannot modify your lineup during this phase.</li>
            <li><span className="font-medium">Completed:</span> Events that have finished. Results and scores are calculated and applied to your league standings.</li>
          </ul>
        </section>
        
        <section>
          <h2 className="text-2xl font-semibold text-dark-grey mb-4">Creating a Lineup</h2>
          <p className="text-medium-grey mb-4">
            To create a lineup for an event:
          </p>
          <ol className="list-decimal pl-5 text-medium-grey space-y-2">
            <li>Navigate to the Events section</li>
            <li>Select an upcoming event</li>
            <li>Choose fighters for your lineup</li>
            <li>Designate one fighter as your "Lock of the Night" for bonus points</li>
            <li>Submit your lineup before the event deadline</li>
          </ol>
        </section>
      </div>
    </div>
  );
};

export default EventsHelp;
